/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinksAppRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/app/GetInstrumentLinks.pb'
import {GetInstrumentLinksAppResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/app/GetInstrumentLinks.pb'


export const getInstrumentLinksApp = (request: GetInstrumentLinksAppRequest, options?: CashRequestOptions) => post<GetInstrumentLinksAppRequest, GetInstrumentLinksAppResponse>("/cash-app/instrument-link/v1.0/get-instruments", request, {...options, rejectOnError: true })